import { mergeClassName as e } from "../../utils/data.js";
import { isColorLexicalName as t, isColorName as n, normalizeColorName as r } from "../../utils/colors.js";
import i from "./Card.module.js";
import { Typography as a } from "../Typography/Typography.js";
import { useMemo as o } from "react";
import { Fragment as s, jsxDEV as c } from "react/jsx-dev-runtime";
//#region lib/components/Card/Card.tsx
var l = "/opt/render/project/src/shared-ui/lib/components/Card/Card.tsx";
function u(e) {
	return e ? t(e) || n(e) : !1;
}
function d(e) {
	return u(e) ? `var(--ag-${r(e)}-2)` : e;
}
function f(e) {
	return u(e) ? `var(--ag-${r(e)}-5)` : e;
}
function p(e, t) {
	if (!u(e)) return e;
	let n = r(e);
	return t ? `var(--ag-${n}-7)` : `var(--ag-${n}-5)`;
}
function m({ children: e }) {
	return /* @__PURE__ */ c(a, {
		alignItems: "center",
		variant: "heading-small",
		className: i.title,
		children: e
	}, void 0, !1, {
		fileName: l,
		lineNumber: 60,
		columnNumber: 9
	}, this);
}
function h({ children: t, className: n, noBorder: r = !1, title: a, divideTitle: u = !1, isClickable: h = !1, style: g, backgroundColor: _, padding: v = 4, titlePadding: y = 4, radius: b = 3, spacing: x = 4, ...S }) {
	let C = o(() => e(i.card, r ? void 0 : i.bordered, h ? i.clickable : void 0, n), [
		r,
		h,
		n
	]), w = u && a, T = o(() => ({
		padding: w ? 0 : `var(--ag-spacing-${String(v)})`,
		borderRadius: `var(--ag-radius-${String(b)})`,
		gap: w ? 0 : `var(--ag-spacing-${String(x)})`,
		"--card-background-color": d(_),
		"--card-border-color": f(_),
		"--card-hover-border-color": p(_, h),
		...g
	}), [
		w,
		v,
		b,
		x,
		_,
		h,
		g
	]);
	return /* @__PURE__ */ c("div", {
		...S,
		title: typeof a == "string" ? a : void 0,
		className: C,
		style: T,
		children: w ? /* @__PURE__ */ c(s, { children: [
			/* @__PURE__ */ c("div", {
				className: i.titleSection,
				style: { padding: `var(--ag-spacing-${String(y)}) var(--ag-spacing-${String(v)})` },
				children: /* @__PURE__ */ c(m, { children: a }, void 0, !1, {
					fileName: l,
					lineNumber: 118,
					columnNumber: 25
				}, this)
			}, void 0, !1, {
				fileName: l,
				lineNumber: 112,
				columnNumber: 21
			}, this),
			/* @__PURE__ */ c("div", { className: i.divider }, void 0, !1, {
				fileName: l,
				lineNumber: 120,
				columnNumber: 21
			}, this),
			/* @__PURE__ */ c("div", {
				className: i.cardBody,
				style: {
					padding: `var(--ag-spacing-${String(v)})`,
					gap: `var(--ag-spacing-${String(x)})`
				},
				children: t
			}, void 0, !1, {
				fileName: l,
				lineNumber: 121,
				columnNumber: 21
			}, this)
		] }, void 0, !0, {
			fileName: l,
			lineNumber: 111,
			columnNumber: 17
		}, this) : /* @__PURE__ */ c(s, { children: [a && /* @__PURE__ */ c(m, { children: a }, void 0, !1, {
			fileName: l,
			lineNumber: 133,
			columnNumber: 31
		}, this), t] }, void 0, !0, {
			fileName: l,
			lineNumber: 132,
			columnNumber: 17
		}, this)
	}, void 0, !1, {
		fileName: l,
		lineNumber: 109,
		columnNumber: 9
	}, this);
}
//#endregion
export { h as Card };
